import { Title } from 'react-head'
import PageWrapper from '../components/PageWrapper'
import WebsiteCard from '../components/WebsiteCard'
import WebsiteAnalytics from '../components/WebsiteAnalytics'
import ConsoleError from '../components/ConsoleError'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { useMemo } from 'react'

const Dashboard = () => {
  const { tr } = useTr()

  const title = useMemo(() => {
    return tr(TrKey.dashboardWebsite) + ' | Atlascloud'
  }, [tr])

  return (
    <PageWrapper>
      <ConsoleError />
      <Title>{title}</Title>
      <div className='flex flex-col gap-16 pb-96'>
        <WebsiteCard />
        <WebsiteAnalytics />
      </div>
    </PageWrapper>
  )
}

export default Dashboard
